module.exports = __webpack_public_path__ + "img/ornament.7f12fc0c.svg";